<template>
    <div class="overflow-x-auto border-b border-gray-325 lg:border-0">
        <div
            class="flex w-[1px] flex-row gap-4 whitespace-nowrap px-4 text-[16px] lg:gap-2 lg:px-0"
        >
            <template
                v-for="contentType in availableContentTypes"
                v-if="selectedContentType"
            >
                <div
                    v-if="selectedContentType.value === contentType.value"
                    class="border-b-4 border-primary-525 py-2 text-[16px] text-primary-525 hover:cursor-pointer lg:rounded-full lg:border lg:border-gray-325 lg:bg-gray-900 lg:px-4 lg:py-2 lg:text-white"
                >
                    {{ contentType.label }}
                </div>

                <div
                    v-else
                    @click="selectContentType(contentType)"
                    class="lg:border-b-1 border-b-4 border-transparent py-2 text-[16px] text-gray-700 hover:cursor-pointer lg:rounded-full lg:border lg:border-gray-325 lg:px-4 lg:py-2 lg:hover:bg-gray-200"
                >
                    {{ contentType.label }}
                </div>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    name: "StudentTableContentTypeSelector",
    emits: ["content-type-selected"],
    props: {
        enabledTypes: {
            type: Array,
            default: [],
        },
        initSelectedContentType: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            contentTypes: [
                {
                    label: "Flashcards",
                    value: "flashcardStacks",
                },
                {
                    label: "Videos",
                    value: "videos",
                },

                {
                    label: "Interactive Exercises",
                    value: "worksheets",
                },
                {
                    label: "Study Guides",
                    value: "studyGuides",
                },
            ],
            selectedContentType: null,
        };
    },
    methods: {
        selectContentType(contentType) {
            this.selectedContentType = contentType;
            this.$emit("content-type-selected", contentType);
        },
    },
    computed: {
        availableContentTypes() {
            let vm = this;

            return _.filter(vm.contentTypes, function (contentType) {
                return _.includes(vm.enabledTypes, contentType.value);
            });
        },
    },
    watch: {
        initSelectedContentType: {
            handler(newValue, oldValue) {
                this.selectedContentType = this.initSelectedContentType;
            },
            deep: false,
        },
    },
};
</script>
